import type { RadioItemType, UpcomingItem } from './radio.types';

const ITEM_TYPE_LABELS: Record<RadioItemType, string | null> = {
  music: null,
  vocal: null,
  jingle: 'Jingiel',
  time: 'Komunikat czasu',
  station_id: 'Identyfikator stacji',
  interlude: 'Przerywnik',
};

/** Etykieta typu dla pozycji, które nie są utworem (albo `null` dla muzyki). */
export function getItemTypeLabel(type: RadioItemType): string | null {
  return ITEM_TYPE_LABELS[type];
}

/** „Artysta – Tytuł" dla utworów, sam tytuł dla pozostałych pozycji. */
export function formatRadioItem(item: UpcomingItem): string {
  const isTrack = item.type === 'music' || item.type === 'vocal';
  return isTrack && item.artist ? `${item.artist} – ${item.title}` : item.title;
}
